import type { Connector } from '../connectors/connectors';
import styles from './Connection.module.css';

interface ConnectorSidebarProps {
    connector: Connector;
}

const ConnectorSidebar = ({ connector }: ConnectorSidebarProps) => (
    <div className={styles.connectorSidebar}>
        {connector.icon && (
            <img
                src={connector.icon}
                alt={connector.name}
                width={56}
                height={56}
                className={styles.connectorIcon}
            />
        )}
        <div className={styles.connectorSidebarName}>{connector.name}</div>
        {connector.description && (
            <div className={styles.connectorSidebarDescription}>{connector.description}</div>
        )}
    </div>
);

export default ConnectorSidebar;
